<template>
  <div id="box">
    <div id="mainBox">
      <div v-if="isPage == 'index'" class="body">
        <div class="flex">
          <ul class="topBox">
            <li class="flex">
              <div style="width: 240px">
                <el-input v-model="searchVle" placeholder="请输入型号名称"></el-input>
              </div>
            </li>

            <li class="flex" style="padding-top: 5px">
              <el-button type="success" size="small" @click="searchFn">搜索</el-button>
            </li>
          </ul>

          <div class="top_right">
            <el-button type="success" size="small" @click="addFn">新增</el-button>
            <el-button type="warning" size="small" @click="returnFn">返回</el-button>
          </div>
        </div>

        <!-- 主体内容 -->
        <div>
          <div class="table-scroll-wrap">
          <el-table :data="tableData" border style="width: 100%; margin-top: 10px">
            <el-table-column align="center" label="型号图片" width="130">
              <template slot-scope="scope">
                <div class="goodsImg" v-if="scope.row.images">
                  <img style="width: 50px" :src="scope.row.images | assetUrl" @error="handleImageError" alt="" srcset="" />
                </div>
              </template>
            </el-table-column>

            <el-table-column prop="name" align="center" label="型号名称" width="130">
            </el-table-column>

            <el-table-column prop="name2" align="center" label="关键词匹配" width="150">
            </el-table-column>

            <el-table-column prop="englishName" align="center" label="英文名称" width="150">
            </el-table-column>

            <el-table-column
              prop="englishName"
              width="200px"
              align="center"
              label="标准图谱(无坐标)"
            >
              <template slot-scope="scope">
                <div class="goodsImg">
                  <img
                    style="width: 150px"
                    @click="previewFn(scope.row.atlas1)"
                    :src="scope.row.atlas1"
                    alt=""
                    srcset=""
                  />
                </div>
              </template>
            </el-table-column>

            <el-table-column
              prop="englishName"
              width="200px"
              align="center"
              label="标准图谱(有坐标)"
            >
              <template slot-scope="scope">
                <div class="goodsImg">
                  <img
                    style="width: 150px"
                    @click="previewFn(scope.row.atlas2)"
                    :src="scope.row.atlas2"
                    alt=""
                    srcset=""
                  />
                </div>
              </template>
            </el-table-column>

            <el-table-column align="center" label="容量管理">
              <template slot-scope="scope">
                <el-button type="success" size="small" @click="capacityFn(scope.row)"
                  >管理</el-button
                >
              </template>
            </el-table-column>

            <el-table-column prop="bzyc" align="center" label="标准乙醇">
            </el-table-column>

            <el-table-column prop="extraJbCost" align="center" label="附收鉴别费(元)" width="150">
            </el-table-column>

            <el-table-column prop="liquidInspection" align="center" label="液体鉴别" width="100">
              <template slot-scope="scope">
                <el-switch v-model="scope.row.liquidInspection" :active-value="1" :inactive-value="0" @change="handleLiquidInspectionChange(scope.row)"></el-switch>
              </template>
            </el-table-column>

            <el-table-column prop="releaseYear" align="center" label="发布年份" width="120">
            </el-table-column>

            <el-table-column prop="attribute" align="center" label="属性">
            </el-table-column>
            <el-table-column prop="perfumer" align="center" label="调香师">
            </el-table-column>
            <el-table-column prop="fragranceNote" align="center" label="香调" width="140px">
            </el-table-column>
            <el-table-column prop="topNote" align="center" label="前调" width="140px">
            </el-table-column>
            <el-table-column prop="middleNote" align="center" label="中调" width="140px">
            </el-table-column>
            <el-table-column prop="baseNote" align="center" label="后调" width="140px">
            </el-table-column>
            <el-table-column prop="smell" align="center" label="气味" width="160px">
            </el-table-column>
            <el-table-column prop="score" align="center" label="评分">
            </el-table-column>
            <el-table-column prop="scoreNum" align="center" label="评分人数">
            </el-table-column>

            <el-table-column width="180" align="center" label="操作" fixed="right">
              <template slot-scope="scope">
                <el-button type="success" size="small" @click="editFn(scope.$index)"
                  >编辑</el-button
                >
                <el-button type="danger" size="small" @click="delFn(scope.$index)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          </div>

          <list-pagination
            :total="tableTotal"
            :current-page.sync="currentPage"
            :page-size.sync="pageSize"
            @page-change="changePage"
            @size-change="handlePageSizeChange"
          />
        </div>
        <!-- 主体内容 -->
      </div>

      <!-- 新增/编辑型号 -->
      <div class="excellent_box" v-if="excellenShow == 1" @click.self="closeFn">
        <div class="excellent_main model-dialog-main">
          <div class="excellent_top">
            <span>{{ addList.id ? '编辑型号' : '新增型号' }}</span>
            <i class="el-icon-close" @click.stop="closeFn"></i>
          </div>

          <div class="excellent_content model-dialog-content">
            <div class="excellent_li">
              <span>型号图片：</span>
              <div style="width: 290px">
                <div style="width: 100px; height: 100px">
                  <elUpload @getImg="getImgFn" :image="addList.images"></elUpload>
                </div>
              </div>
            </div>

            <div class="excellent_li">
              <span>标准谱图：</span>
              <div style="width: 290px">
                <div class="imgLi">
                  <div style="height: 100px">
                    <elUpload @getImg="getImgFn2" :image="addList.atlas1"></elUpload>
                  </div>
                  <div class="imgLi_text">无坐标</div>
                </div>

                <div class="imgLi">
                  <div style="height: 100px">
                    <elUpload @getImg="getImgFn3" :image="addList.atlas2"></elUpload>
                  </div>
                  <div class="imgLi_text">有坐标</div>
                </div>
              </div>
            </div>

            <div class="excellent_li flex">
              <span>型号名称：</span>
              <div style="width: 290px">
                <el-input
                  size="medium"
                  v-model="addList.name"
                  placeholder="请填型号名称"
                ></el-input>
              </div>
            </div>
            <div class="excellent_li flex">
              <span>关键词匹配：</span>
              <div style="width: 290px">
                <el-input
                  size="medium"
                  v-model="addList.name2"
                  placeholder="请填型号名称"
                ></el-input>
              </div>
            </div>

            <div class="excellent_li flex">
              <span>英文名称：</span>
              <div style="width: 290px">
                <el-input
                  size="medium"
                  v-model="addList.englishName"
                  placeholder="请填写英文名称"
                ></el-input>
              </div>
            </div>
            <div class="excellent_li flex">
              <span>标准乙醇：</span>
              <div style="width: 290px">
                <el-input
                  size="medium"
                  v-model="addList.bzyc"
                  placeholder="请填写英文名称"
                ></el-input>
              </div>
            </div>
            <div class="excellent_li flex">
              <span>额外鉴别金额：</span>
              <div style="width: 290px">
                <el-input
                  size="medium"
                  v-model="addList.extraJbCost"
                  placeholder="请填写金额"
                ></el-input>
              </div>
            </div>

            <div class="excellent_li flex">
              <span>发布年份：</span>
              <div style="width: 290px">
                <el-input
                  size="medium"
                  v-model.number="addList.releaseYear"
                  placeholder="如 2017"
                ></el-input>
              </div>
            </div>

            <div class="excellent_li flex">
              <span>属性：</span>
              <div style="width: 290px">
                <el-input
                  size="medium"
                  v-model="addList.attribute"
                  placeholder="请填写属性"
                ></el-input>
              </div>
            </div>

            <div class="excellent_li flex">
              <span>调香师：</span>
              <div style="width: 290px">
                <el-input
                  size="medium"
                  v-model="addList.perfumer"
                  placeholder="请填写调香师"
                ></el-input>
              </div>
            </div>

            <div class="excellent_li flex">
              <span>香调：</span>
              <div style="width: 290px">
                <el-input
                  size="medium"
                  v-model="addList.fragranceNote"
                  placeholder="多个以逗号分隔"
                ></el-input>
              </div>
            </div>

            <div class="excellent_li flex">
              <span>前调：</span>
              <div style="width: 290px">
                <el-input
                  size="medium"
                  v-model="addList.topNote"
                  placeholder="多个以逗号分隔"
                ></el-input>
              </div>
            </div>

            <div class="excellent_li flex">
              <span>中调：</span>
              <div style="width: 290px">
                <el-input
                  size="medium"
                  v-model="addList.middleNote"
                  placeholder="多个以逗号分隔"
                ></el-input>
              </div>
            </div>

            <div class="excellent_li flex">
              <span>后调：</span>
              <div style="width: 290px">
                <el-input
                  size="medium"
                  v-model="addList.baseNote"
                  placeholder="多个以逗号分隔"
                ></el-input>
              </div>
            </div>

            <div class="excellent_li flex">
              <span>气味：</span>
              <div style="width: 290px">
                <el-input
                  size="medium"
                  v-model="addList.smell"
                  placeholder="请填写气味"
                ></el-input>
              </div>
            </div>

            <div class="excellent_li flex">
              <span>评分：</span>
              <div style="width: 290px">
                <el-input
                  size="medium"
                  v-model="addList.score"
                  placeholder="如 4.5"
                ></el-input>
              </div>
            </div>

            <div class="excellent_li flex">
              <span>评分人数：</span>
              <div style="width: 290px">
                <el-input
                  size="medium"
                  v-model.number="addList.scoreNum"
                  placeholder="请填写评分人数"
                ></el-input>
              </div>
            </div>

          </div>

          <div class="excellent_footer model-dialog-footer">
            <el-button type="success" size="small" @click.stop="excellentFn">提交</el-button>
            <el-button type="info" size="small" @click.stop="closeFn">取消</el-button>
          </div>
        </div>
      </div>

      <!-- 容量管理 -->
      <popupBox title="容量管理" v-if="isCapacity">
        <div class="popupMain">
          <div class="popupLi flex" v-for="(item, index) in capacityArr" :key="index">
            <div class="capacityLi flex">
              <span class="capacityLi_text">容量</span>
              <input type="text" v-model="item.ml" placeholder="请输入" />
              <span class="capacityLi_text">ml</span>
            </div>
          </div>
        </div>

        <div class="popupBtn flex">
          <el-button type="success" size="small" @click="confirmCapacityFn"
            >确认</el-button
          >
          <el-button type="info" size="small" @click="closeCapacityFn">取消</el-button>
        </div>
      </popupBox>
      <!-- 容量管理 -->

    </div>
  </div>
</template>

<script>
import { delTips, returnTime, throttle, isJSON } from "@/util/utils";
import elUpload from "@/components/elUpload";
import popupBox from "@/components/popupBox";

export default {
  components: {
    elUpload,
    popupBox,
  },
  props: {
    dataList: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      isPage: "index",

      surplusShow: 0,
      userList: "",

      // 历史记录
      historyArr: ["用户管理"],

      //  搜索
      searchVle: "",

      // 品牌
      excellenShow: 0,

      // 添加数据
      addList: {
        name: "",
        name2: "",
        englishName: "",
        images: "",
        atlas1: "",
        atlas2: "",
        capacity: "",
        releaseYear: "",
        attribute: "",
        perfumer: "",
        fragranceNote: "",
        topNote: "",
        middleNote: "",
        baseNote: "",
        smell: "",
        score: "",
        scoreNum: "",
      },

      tempList: {},

      isCapacity: false,
      capacityArr: [],
      tempCapacity: [
        { ml: "", price: "" },
        { ml: "", price: "" },
        { ml: "", price: "" },
        { ml: "", price: "" },
        { ml: "", price: "" },
      ],

      // 数据信息
      tableData: [],
      pageSize: 10,
      currentPage: 1,
      tableTotal: 0,
    };
  },
  mounted() {
    this.selListFn(1);
  },
  methods: {
    // 图片加载失败处理
    handleImageError(e) {
      e.target.src = 'static/image/error.jpeg';
    },

    // 搜索
    searchFn: function (res) {
      this.selListFn(1);
      this.currentPage = 1;
    },

    // 液体鉴别开关改变
    handleLiquidInspectionChange(row) {
      let obj = {
        id: row.id,
        liquidInspection: row.liquidInspection,
      };
      let urls = this.$api.api.upModel;
      this.$https(urls, obj, "POST").then((res) => {
        if (res.data.code == 200) {
          this.$message.success("更新成功");
        } else {
          this.$message.error(res.data.msg || "更新失败");
        }
      });
    },

    // 新增
    addFn() {
      this.addList = {
        name: "",
        name2: "",
        englishName: "",
        images: "",
        atlas1: "",
        atlas2: "",
        bzyc: "",
        extraJbCost: "",
        releaseYear: "",
        attribute: "",
        perfumer: "",
        fragranceNote: "",
        topNote: "",
        middleNote: "",
        baseNote: "",
        smell: "",
        score: "",
        scoreNum: "",
      };
      this.excellenShow = 1;
    },

    // 编辑
    editFn: function (index) {
      var list = this.tableData[index];
      this.addList = list;
      this.excellenShow = 1;
    },

    closeFn: function () {
      this.excellenShow = 0;
      this.pageChangeShow = 1;
      this.selListFn(this.currentPage);
    },

    capacityFn(list) {
      this.isCapacity = true;
      this.tempList = list;

      if (list.capacity) {
        this.capacityArr = isJSON(list.capacity)
          ? JSON.parse(list.capacity)
          : list.capacity;
      } else {
        this.capacityArr = JSON.parse(JSON.stringify(this.tempCapacity));
      }
    },

    confirmCapacityFn: throttle(function () {
      let arr = JSON.parse(JSON.stringify(this.capacityArr));

      let hasCapacity = false;
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].ml) {
          hasCapacity = true;
          break;
        }
      }

      if (!hasCapacity) {
        this.$message.error("至少填写一个容量信息");
        return;
      }

      let list = this.tempList;
      var obj = {
        id: list.id,
        capacity: JSON.stringify(arr),
      };

      this.$https(this.$api.api.upModel, obj, "POST").then((res) => {
        if (res.data.code == 200) {
          this.$message.success("操作成功");
          this.closeCapacityFn();
          this.selListFn(this.currentPage);
        } else {
          this.$message.error("操作失败");
        }
      });
    }),

    closeCapacityFn() {
      this.isCapacity = false;
    },

    // 图片上传
    getImgFn: function (res) {
      this.$set(this.addList, "images", res);
    },

    // 图片上传
    getImgFn2: function (res) {
      this.$set(this.addList, "atlas1", res);
    },

    // 图片上传
    getImgFn3: function (res) {
      this.$set(this.addList, "atlas2", res);
    },

    excellentFn: throttle(function () {
      var data = this.addList;
      if (!data.images) {
        this.$message.error("请上传图片");
        return;
      }

      // if (!data.atlas1) {
      //   this.$message.error("请上传图谱");
      //   return;
      // }

      // if (!data.atlas2) {
      //   this.$message.error("请上传图谱");
      //   return;
      // }
      if (!data.name) {
        this.$message.error("请输入品牌名称");
        return;
      }
      if (!data.name2) {
        this.$message.error("请输入关键词匹配");
        return;
      }
      if (!data.englishName) {
        this.$message.error("请输入英文名称");
        return;
      }
      if (!data.bzyc) {
        this.$message.error("请输入标准乙醇");
        return;
      }
      var obj = {
        atlas1: data.atlas1,
        atlas2: data.atlas2,
        images: data.images,
        name: data.name,
        name2: data.name2,
        englishName: data.englishName,
        bzyc: data.bzyc,
        extraJbCost: data.extraJbCost,
        releaseYear: data.releaseYear || null,
        attribute: data.attribute,
        perfumer: data.perfumer,
        fragranceNote: data.fragranceNote,
        topNote: data.topNote,
        middleNote: data.middleNote,
        baseNote: data.baseNote,
        smell: data.smell,
        score: data.score || null,
        scoreNum: data.scoreNum || null,
        brandId: this.dataList.id,
      };

      let urls = this.$api.api.addModel;
      if (data.id) {
        urls = this.$api.api.upModel;
        obj.id = data.id;
      }

      // return
      this.$https(urls, obj, "POST").then((res) => {
        if (res.data.code == 200) {
          this.$message.success("操作成功");
          this.closeFn();
        } else {
          this.$message.error("操作失败");
        }
      });
    }),

    // 查询
    selListFn: function (page) {
      var obj = {
        page: page,
        size: this.pageSize,
        brandId: this.dataList.id,
      };

      if (this.searchVle) {
        obj.name = this.searchVle;
      }

      this.$https(this.$api.api.selModel, obj, "POST").then((res) => {
        if (res.data.code == 200) {
          var data = res.data.data;
          this.tableData = data;
          this.tableTotal = res.data.size;
        } else {
          this.tableData = [];
          this.tableTotal = 0;
        }
      });
    },

    // 返回
    returnFn(res) {
      this.$emit("return", {});
    },

    // 分页
    changePage: function (res) {
      this.selListFn(res);
    },

    handlePageSizeChange() {
      this.selListFn(this.currentPage);
    },

    // 删除
    delFn: delTips(function (index) {
      var list = this.tableData[index];

      this.$https(
        this.$api.api.delType,
        {
          id: list.id,
        },
        "GET"
      ).then((res) => {
        if (res.data.code == 200) {
          this.selListFn(this.currentPage);
          this.$message.success("操作成功");
        } else {
          this.$message.error(res.data.msg);
        }
      });
    }),
  },
};
</script>

<style lang="less" scoped>
#box {
  width: 100%;

  .body {
    margin-top: 20px;
  }

  .top_right {
    display: flex;
  }

  .topBox {
    width: 100%;
    margin-top: 10px;
    overflow: hidden;
    font-size: 15px;

    li {
      float: left;
      margin-right: 20px;
      margin-bottom: 10px;

      .el-range-editor.el-input__inner {
        width: 290px;
      }
    }

    li:last-child {
      margin-right: 0px;
    }

    span {
      margin-right: 5px;
    }
  }
}

// 新增/编辑型号弹窗
.excellent_box {
  width: 100%;
  height: 100vh;
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 16px;
  box-sizing: border-box;

  .excellent_main {
    width: 600px;
    max-width: 100%;
    background: #fff;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);

    &.model-dialog-main {
      max-height: calc(100vh - 48px);
      display: flex;
      flex-direction: column;
    }

    .excellent_top {
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 48px;
      padding: 0 16px;
      background: #f5f5f5;
      border-bottom: 1px solid #e8e8e8;
      font-size: 15px;
      font-weight: 500;

      i {
        font-size: 20px;
        cursor: pointer;
        color: #666;
        padding: 4px;
        border-radius: 4px;

        &:hover {
          color: #333;
          background: #e8e8e8;
        }
      }
    }

    .excellent_content {
      flex: 1;
      min-height: 0;
      overflow-y: auto;
      padding: 8px 16px 0;

      &.model-dialog-content {
        .excellent_li {
          margin-top: 16px;

          &:first-child {
            margin-top: 8px;
          }
        }
      }

      .excellent_li {
        display: flex;

        .el-select {
          width: 100%;
        }

        .imgLi {
          width: 100%;
          margin-bottom: 20px;

          .imgLi_text {
            text-align: center;
            margin-top: 5px;
          }
        }

        span {
          width: 120px;
          display: inline-block;
          flex-shrink: 0;
          text-align: right;
          padding-right: 12px;
          line-height: 36px;
        }
      }
    }

    .excellent_footer {
      flex-shrink: 0;
      display: flex;
      justify-content: flex-end;
      gap: 10px;
      padding: 12px 16px;
      border-top: 1px solid #e8e8e8;
      background: #fafafa;
    }
  }
}

//弹框数据

.popupMain {
  width: 100%;
  padding: 5px 10px;
  box-sizing: border-box;

  .popupLi {
    width: 100%;
    height: 40px;
    justify-content: space-between;
    margin-top: 10px;

    .capacityLi {
      width: 49%;
      height: 38px;
      font-size: 13px;
      color: #666;
      padding: 4px 5px;
      box-sizing: border-box;
      border: 1px solid #eee;
      border-radius: 5px;

      .capacityLi_text {
        flex-shrink: 0;
      }

      input {
        width: 100%;
        height: 100%;
        border: 0;
        margin: 0px 3px;
        text-align: center;
      }
    }
  }
}

.popupBtn {
  justify-content: flex-end;
  margin: 10px auto auto auto;

  .popupBtnLi {
    cursor: pointer;
    margin-right: 6px;
  }
}

// 弹框数据
</style>



// WEBPACK FOOTER //
// src/pages/brand/model.vue